import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { CreateTipoGastoDto, UpdateTipoGastoDto, ReadTipoGastoDto } from '@/api.types';
import { DeleteTipoGasto, GetTipoGasto, SetTipoGasto } from './tipo-gasto.service';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { useNavigate } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function TipoGastoEditPage() {
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.TipoGasto_Criar, onClick: () => {} },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  const { register, handleSubmit, reset, watch } = useForm<ReadTipoGastoDto>({
    defaultValues: {
      descricao: '',
      coluna1: '',
      coluna2: '',
      coluna3: '',
    },
  });

  const editadoPor = watch('editadoPor');
  const editadoEm = watch('editadoEm');

  useEffect(() => {
    if (id > 0) {
      GetTipoGasto(id)
        .then((result) => {
          if (result) {
            reset(result);
          }
        })
        .catch((res) => {
          toast.error((res as string) + '');
        })
    }
  }, [id, reset]);

  const onSubmit: SubmitHandler<ReadTipoGastoDto> = (data) => {
    setIsLoading(true);

    const dataToSave: CreateTipoGastoDto | UpdateTipoGastoDto = {
      id: id > 0 ? id : undefined,
      descricao: data.descricao || '',
      coluna1: data.coluna1 || undefined,
      coluna2: data.coluna2 || undefined,
      coluna3: data.coluna3 || undefined,
    };

    SetTipoGasto(dataToSave)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.TipoGasto_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setModalExcluirShow(false);
    DeleteTipoGasto(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.TipoGasto_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Tipo de Gasto</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="mb-3 col-md-12">
            <label htmlFor="descricao" className="form-label">
              Descrição: *
            </label>
            <input
              id="descricao"
              title="Descrição"
              type="text"
              className="form-control"
              {...register('descricao', { required: true })}
            />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="coluna1" className="form-label">
              Nome da Coluna 1:
            </label>
            <input
              id="coluna1"
              title="Nome da Coluna 1"
              type="text"
              className="form-control"
              {...register('coluna1')}
            />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="coluna2" className="form-label">
              Nome da Coluna 2:
            </label>
            <input
              id="coluna2"
              title="Nome da Coluna 2"
              type="text"
              className="form-control"
              {...register('coluna2')}
            />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="coluna3" className="form-label">
              Nome da Coluna 3:
            </label>
            <input
              id="coluna3"
              title="Nome da Coluna 3"
              type="text"
              className="form-control"
              {...register('coluna3')}
            />
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: editadoPor ? { username: editadoPor.username } : undefined,
              editadoEm: editadoEm,
            }}
          />
          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      />
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.tipo_gasto}
        idRegistro={id}
      />
    </>
  );
}